export default "__VITE_ASSET__Bgbrr_qb__"